import { FormGroup, ValidationErrors } from '@angular/forms';

export function declaredValueValidator(
  group: FormGroup
): ValidationErrors | null {
  const declaredValueControl = group.get('declared_value'); // ОЦ
  const cashOnDeliveryControl = group.get('cash_on_delivery'); // HП

  if (declaredValueControl && cashOnDeliveryControl) {
    const declaredValue = Number(declaredValueControl.value);
    const cashOnDelivery = Number(cashOnDeliveryControl.value);

    if (declaredValue && cashOnDelivery && declaredValue < cashOnDelivery) {
      declaredValueControl.setErrors({
        error:
          'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.VALIDATION_DECLARE_VALUE',
      });

      return { error: true };
    } else if (
      declaredValue >= cashOnDelivery &&
      Array.isArray(declaredValueControl.errors)
    ) {
      declaredValueControl.setErrors(null);
    }
    if (declaredValue === cashOnDelivery && cashOnDelivery > 0) {
      declaredValueControl.setErrors(null);
    }
  }

  return null;
}
